import React from 'react';
import { Card, Typography } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface StatCardProps {
  title: string;
  value: string | number;
  growth?: string;
  icon?: React.ReactNode;
  color?: 'default' | 'primary' | 'success' | 'warning' | 'error';
  bordered?: boolean;
  hoverable?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  growth,
  icon,
  color = 'default',
  bordered = false,
  hoverable = true,
}) => {
  // 映射颜色到实际的CSS类名
  const colorMap = {
    default: 'default',
    primary: 'blue',
    success: 'green',
    warning: 'orange',
    error: 'red',
  };

  return (
    <Card
      bordered={bordered}
      hoverable={hoverable}
      style={{ height: '100%' }}
      bodyStyle={{ padding: '24px 20px', display: 'flex', flexDirection: 'column' }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
        <div>
          <Text type="secondary" style={{ fontSize: '14px', display: 'block', marginBottom: 8 }}>
            {title}
          </Text>
          <Title level={2} style={{ margin: 0, fontWeight: 600 }}>
            {value}
          </Title>
        </div>
        {icon && (
          <div style={{ color: `#${colorMap[color] === 'default' ? '1890ff' : colorMap[color]}`, fontSize: '24px' }}>
            {icon}
          </div>
        )}
      </div>
      {growth && (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 'auto' }}>
          <ArrowUpOutlined style={{ color: '#52c41a', marginRight: 4, fontSize: '12px' }} />
          <Text type="success" style={{ fontSize: '14px' }}>
            {growth}
          </Text>
        </div>
      )}
    </Card>
  );
};

export default StatCard;
